/*
  Done.jsx
*/

import React from 'react';
import SvgIcon from '../components/SvgIcon';

export default function Done(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
    </SvgIcon>
  );
}
